<template>
  <BaseTextViewer :text="editedAward.description || ''" @click:close="$emit('click:close')" />
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BaseTextViewer from '../../components/base/BaseTextViewer';

export default {
  name: 'ViewAwardsText',

  components: { BaseTextViewer },

  computed: mapState('awards', ['editedAward']),

  created() {
    this.editAward(+this.$route.params.id);
  },

  methods: mapActions('awards', ['editAward']),
};
</script>

<style scoped></style>
